import React from "react";
import ReactDOM from "react-dom/client";
// IMPORTANT: storageMigration must run before any module that reads localStorage
// (AuthContext picks up the access token synchronously at import-time).
import "@/lib/storageMigration";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/swRegister";
import { installForceOfflineInterceptor } from "@/lib/forceOffline";
import { initDevTopupPickerFromUrl } from "@/lib/devTopupPicker";

// Install the force-offline axios interceptor before React mounts so the very
// first /api/auth/me call respects an active flag.
installForceOfflineInterceptor();
initDevTopupPickerFromUrl();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
